// ========================================
// COMPONENTS / WhyUs.jsx
// ========================================

import React from "react";
import { WHY_US } from "../data";
import styles from "./WhyUs.module.css";

function FeatureCard({ item }) {
  return (
    <div className={styles.card}>
      <div className={styles.icon}>{item.icon}</div>
      <h3 className={styles.title}>{item.title}</h3>
      <p className={styles.desc}>{item.desc}</p>
    </div>
  );
}

export default function WhyUs() {
  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.sectionTitle}>WHY MOON BERRY</h2>
        </div>

        <div className={styles.grid}>
          {WHY_US.map((item, i) => (
            <FeatureCard key={i} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}
